import { HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { ORGANIZATION_ID } from '@context/frontend/common';
import { iif, of, switchMap } from 'rxjs';
import { GuestAuthService } from '../services';

const HeaderKey = 'Authorization';
export function guestAuthBearerInterceptor(
	req: HttpRequest<unknown>,
	next: HttpHandlerFn,
) {
	const guestAuth = inject(GuestAuthService);

	const organizationId$ = inject(ORGANIZATION_ID);
	const organizationId = organizationId$.value;

	const firebaseUser = guestAuth.firebaseUser();
	if (!firebaseUser) return next(req);

	return iif(
		() => !req.headers.has(HeaderKey),
		new Promise((resolve) =>
			firebaseUser.getIdToken().then((token) => {
				let headers = req.headers;

				if (token) {
					headers = headers.set(HeaderKey, `Bearer ${token}`);
				}

				if (organizationId) {
					headers = headers.set('Organization', organizationId);
				}

				req = req.clone({ headers });
				return resolve(req);
			}),
		),
		of(null),
	).pipe(switchMap(() => next(req)));
}
